<template>
  <b-row>
    <b-col>
      <b-row>
        <b-col>
          <!--<div v-if="isLoading" class="alert alert-info">{{$t('alerts.loading')}}...</div>-->
          <div v-if="deletedItem" class="alert alert-success">{{ deletedItem['name'] }} {{$t('notifications.deleted')}}</div>
          <div v-if="error" class="alert alert-danger">{{ error }}</div>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-row>
            <b-col class="text-right">
              <router-link :to="{ name: 'EXSBMeasureCreate' }" class="btn btn-primary">{{ $t('buttons.create') }}</router-link>
            </b-col>
          </b-row>
          <b-card>
<!--            <div class="card-header">-->
<!--              <h4 class="card-title">{{$t('views.exsbmeasures.list.title')}}</h4>-->
<!--            </div>-->
            <div class="card-body">
              <Loader v-if="isLoading" size="lg"></Loader>
              <template v-else>
                <b-row>
                  <b-col>
                    <div v-if="items.length > 0">
                      <table class="table table-sm table-striped table-hover">
                        <thead>
                        <tr>
                          <th>{{$t('views.exsbmeasures.list.name')}}</th>
                          <th colspan="1" />
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="item in items" :key="item['@id']">
                          <td>
                            <!--<router-link-->
                            <!--v-if="item"-->
                            <!--:to="{name: 'EXSBMeasureShow', params: { id: item['@id'] }}">-->
                            <!--{{ item['name'] }}-->
                            <!--</router-link>-->
                            {{ item['name'] }}
                          </td>
                          <!--<td>-->
                          <!--<router-link :to="{name: 'EXSBMeasureShow', params: { id: item['@id'] }}">-->
                          <!--<span class="fa fa-search" aria-hidden="true" />-->
                          <!--<span class="sr-only">{{ $t('buttons.show') }}</span>-->
                          <!--</router-link>-->
                          <!--</td>-->
                          <td>
                              <router-link :to="{name: 'EXSBMeasureUpdate', params: { id: item['@id'] }}" class="float-right">
                                <button class="btn btn-link fa fa-pencil" v-b-tooltip.hover :title="$t('buttons.edit')" aria-hidden="true" />
                              </router-link>
                          </td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                    <p v-else>{{$t('views.exsbmeasures.list.noMeasures')}}</p>
                  </b-col>
                </b-row>
              </template>
            </div>
          </b-card>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { checkPagePermission } from '@/utils/checkRoles.js'
import Loader from '../../../Layout/Loader'

export default {
  components: {
    Loader
  },

  computed: mapGetters({
    deletedItem: 'exsbmeasure/del/deleted',
    error: 'exsbmeasure/list/error',
    items: 'exsbmeasure/list/items',
    isLoading: 'exsbmeasure/list/isLoading',
    view: 'exsbmeasure/list/view'
  }),

  beforeCreate () {
    checkPagePermission('warehouses', 'EXSBMeasureList')
  },

  created () {
    this.getPage()
    this.channelBusinessMeasures = this.$store.state.Pusher.subscribe('e_x_s_b_measures')
    this.channelBusinessMeasures.bind('e_x_s_b_measures', data => {
      this.getPage()
    })
  },

  destroyed () {
    this.$store.state.Pusher.unsubscribe('e_x_s_b_measures')
  },

  methods: mapActions({
    getPage: 'exsbmeasure/list/default'
  })
}
</script>
